import { capitalize } from 'lodash'
import React, { FC, useCallback, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import { get, ON_DEMAND_APIS } from '../../../apis/onDemandApi'
import { appendPosters, initialAbstractState, setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { MOBILE_THRESHOLD } from '../../../styles/theme'
import { useWindowSize } from '../../../utils/useWindowSize'
import LoadIcon from '../../LoadIcon'
import { Loader } from '../../shared/Loader'
import { ListItem } from './ListItem'

export const PosterAbstractList: FC<RouteComponentProps> = ({ match }) => {
  const areaOfInterest = match.params['areaOfInterest']
  const dispatch = useDispatch()
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const { posters } = useSelector((state) => state.onDemand)
  const { windowWidth, windowHeight } = useWindowSize()

  const currentAreaPosters = posters[areaOfInterest] ?? initialAbstractState

  const fetchPosters = useCallback(() => {
    get(
      ON_DEMAND_APIS.POSTERS,
      (data) => {
        setPageLoading(false)
        dispatch(
          appendPosters(areaOfInterest, {
            abstracts: data.abstracts,
            totalPages: data.total_pages,
          })
        )
      },
      (error) => {
        setPageLoading(false)
        console.error(error)
      },
      {
        page: currentAreaPosters.currentPage || 1,
        area_of_interest: areaOfInterest,
      }
    )
  }, [areaOfInterest, currentAreaPosters.currentPage, dispatch])

  useEffect(() => {
    dispatch(setPreviousPage(routes.onDemandPoster))
  }, [dispatch])

  useEffect(() => {
    dispatch(setPageTitle(areaOfInterest))
    if (!currentAreaPosters.fetchedInitial) {
      setPageLoading(true)
      fetchPosters()
    }
  }, [areaOfInterest, currentAreaPosters.fetchedInitial, dispatch, fetchPosters, posters])

  const infiniteScrollHeight = windowHeight - (windowWidth <= MOBILE_THRESHOLD ? 120 : 110)

  return (
    <Loader fullPage loading={pageLoading}>
      <InfiniteScroll
        height={infiniteScrollHeight}
        dataLength={currentAreaPosters.abstracts.length}
        next={fetchPosters}
        hasMore={!pageLoading && currentAreaPosters.currentPage < currentAreaPosters.totalPages + 1}
        loader={
          <div className="position-relative my-5">
            <LoadIcon />
          </div>
        }
        endMessage={<p className="text-center text-muted">-- End --</p>}
        scrollThreshold={0.9}
      >
        <>
          {currentAreaPosters.abstracts.map((poster) => (
            <ListItem key={poster.id} abstractType="poster" title={poster.title} subtitle={capitalize(poster.presenting_author_name)} abstractId={poster.id} />
          ))}
        </>
      </InfiniteScroll>
    </Loader>
  )
}
